<template>
  <div>
    <v-btn-toggle active-class="cardBtn-active" class="d-flex" mandatory>
      <v-btn class="flex-grow-1 bt-lr-0" @click="showAll(false)">
        Vis mine
      </v-btn>
      <v-btn class="flex-grow-1 bt-rr-0" @click="showAll(true)">
        Vis alle
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { mapActions } from "vuex";
export default Vue.extend({
  props: {
    projectId: {
      default: "",
    },
    filterNameProject: {
      required: true,
      default: null,
    },
    houseName: {
      default: null,
    },
    filterNameHouse: {
      required: true,
      default: null,
    },
    routeName: {
      type: String,
      default: null,
    },
  },
  methods: {
    ...mapActions({
      setFilter: "tables/setFilter",
      resetToDefault: "tables/resetToDefault",
    }),
    showAll(value: boolean) {
      if (this.routeName) {
        var headers = [
          {
            filterValues: this.houseName,
            filterName: this.filterNameHouse,
          },
        ] as Array<any>;

        if (this.projectId) {
          headers.push({
            filterValues: [parseInt(this.projectId)],
            filterName: this.filterNameProject,
          });
        }

        var filter = {
          showAll: value,
          headers: headers,
        };
        if (!this.houseName && !this.projectId) {
          localStorage.removeItem("tableBt");
          this.resetToDefault();
        }
        this.setFilter(filter);

        this.$router.push({ name: this.routeName });
      } else {
        this.$emit("showAll");
      }
    },
  },
});
</script>
